import React__default, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import 'bootstrap/dist/css/bootstrap.css';
import './textarea.scss.js';
import { styled } from 'styled-components';

const InputStyled = styled.textarea `
  box-shadow: none !important;
  outline: none !important;

  &:focus {
    border-color: #8a00e5 !important;
  }
`;
const Textarea = ({ size = 'medium', readonly = false, autogrow = true, disabled = false, height = 100, width = '100%', ...props }) => {
    const ref = useRef(null);
    const textareaRef = useRef(null);
    const handleInput = (event) => {
        const { value } = event.target;
        // Use parentElement instead of parentNode
        // Calculate the number of lines
        const numberOfLines = (value.match(/\n/g) || []).length + 1;
        // Adjust the overflow style based on the number of lines
        if (textareaRef.current) {
            textareaRef.current.style.overflow =
                numberOfLines > 5 ? 'auto' : 'hidden';
            if (event.target.parentElement && numberOfLines <= 5) {
                event.target.parentElement.dataset.replicatedValue = value;
            }
        }
        // Call the original onChange handler if provided
        if (props.onChange) {
            props.onChange(event);
        }
    };
    useEffect(() => {
        if (props.autofocus && textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [props.autofocus]);
    useEffect(() => {
        //Used to reset the component
        if (props.value === '' && ref.current)
            ref.current.dataset.replicatedValue = '';
    }, [props.value]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: "reactLib__Textarea", style: { width: width } },
            props.label ? (React__default.createElement("label", { style: { textAlign: 'left' }, htmlFor: props.id }, props.label)) : null,
            React__default.createElement("div", { ref: ref, className: autogrow
                    ? classNames('grow-wrap', {
                        'grow-wrap-sm': size === 'small',
                        'grow-wrap-lg': size === 'large',
                    })
                    : undefined },
                React__default.createElement(InputStyled, { ref: textareaRef, autoFocus: props.autofocus, id: props.id, maxLength: props.maxLength, minLength: props.minLength, name: props.id, defaultValue: props.defaultValue, value: props.value, placeholder: props.placeholder, readOnly: readonly, disabled: disabled, onChange: autogrow ? handleInput : props.onChange, onClick: props.onClick, onFocus: props.onFocus, onBlur: props.onBlur, onInput: props.onInput, onKeyDown: props.onKeyDown, onKeyPress: props.onKeyPress, onKeyUp: props.onKeyUp, autoComplete: "off", rows: autogrow ? 1 : undefined, style: {
                        width: width,
                        resize: 'none',
                        height: autogrow ? undefined : height,
                    }, className: classNames('form-control', props.className, {
                        'form-control-sm': size === 'small',
                        'form-control-lg': size === 'large',
                    }) }, props.value)))));
};

export { Textarea as default };
//# sourceMappingURL=Textarea.js.map
